module.exports = __webpack_public_path__ + "assets/img/delivery.623a37a4.jpg";